import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";

export type EllipsesMenuStockProps = {
  OnDownloadHistory?: () => void;
  OnDownloadStock?: () => void;
  OnActiveDeactivatedApp?: () => void;
  isAppStockActive?: boolean;
};

const EllipsesMenuStock: React.FC<EllipsesMenuStockProps> = ({
  OnDownloadHistory,
  OnDownloadStock,
  OnActiveDeactivatedApp,
  isAppStockActive,
}) => {
  return (
    <Menu as="div" className="relative flex-none mt-1 md:mt-0">
      <MenuButton className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-6 w-6"
        />
      </MenuButton>
      <MenuItems
        transition
        className="absolute md:right-0 z-50 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <MenuItem>
          <a
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left"
            onClick={OnDownloadHistory}
          >
            {t("store.views.download_history")}
          </a>
        </MenuItem>
        <MenuItem>
          <a
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left"
            onClick={OnDownloadStock}
          >
            {t("store.views.download_stock")}
          </a>
        </MenuItem>
        <MenuItem>
          <a
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left"
            onClick={OnActiveDeactivatedApp}
          >
            {isAppStockActive
              ? t("store.views.deactivate_app")
              : t("store.views.activate_app")}
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuStock;
